import { observer } from 'mobx-react';

import * as React from 'react';
import styles from './DeleteLocationModal.module.scss';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../../../UI/modal/Modal';
import { templateReplace } from '../../../../../utils/template';
import { Button } from '../../../../UI/buttons/regular/Button';
import { DeleteLocationModalModelType } from '../../../../../internal';

export const DeleteLocationModal = observer(
  (props: { model: DeleteLocationModalModelType }): JSX.Element => {
    const { model } = props;
    const { t } = useTranslation();
    return (
      <Modal
        styles={{
          content: {
            minWidth: '40%',
            maxHeight: 'fit-content',
            borderRadius: '20px',
            padding: '40px',
          },
        }}
        model={model.modal}
      >
        <div className={styles.ModalHeader}>
          {' '}
          {templateReplace(
            t('basic:are_you_sure_delete_store'),
            'x',
            model?.location?.name
          )}
        </div>
        <div className={styles.ButtonModalContainer}>
          <Button
            onClick={() => {
              model.delete();
            }}
          >
            {t('basic:yes')}
          </Button>
          <button
            className={styles.BtnNo}
            onClick={() => {
              model.cancel();
            }}
          >
            {t('basic:no')}
          </button>
        </div>
      </Modal>
    );
  }
);
